<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  {{news.textParams[0]}}
  {{$t('news.template.party.updatedName.p1')}}
  <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[1]}}"
  >{{news.textParams[2]}}</router-link>.
  {{news.textParams[0]}}
  {{$t('news.template.party.updatedName.p2')}}
  <router-link :to="{name: 'forum', params: {id: news.textParams[3]}}"
  >{{news.textParams[4]}}</router-link>.
</div>
</template>
